module.exports = __webpack_public_path__ + "img/gallery.910ed30b.svg";